import { render, staticRenderFns } from "./Diametros.vue?vue&type=template&id=018e4b52&"
import script from "./Diametros.vue?vue&type=script&lang=js&"
export * from "./Diametros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports